import * as types from '../../mutationTypes';

const emptyLink = {
  id: '',
  version: 0,
  icon: '',
  url: '',
  title: '',
  description: '',
  tags: [],
  organisation: '',
  hidden: false,
  priority: 0,
  created_at: new Date(),
  updated_at: new Date()
};

export default {
  [types.RESET_QUICK_LINK_CONTENT](state) {
    state.link = emptyLink;
  },
  [types.ASSIGN_LIST](state, link) {
    state.quickLinks = link;
  }
};
